module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof40"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("In 1796, Paul abolished the rank of brigadier and combined the ranks of premier and second majors. He removed the rank of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shtyk-Junker")]), _vm._v(" (artillery) and allowed non-nobles to receive the rank of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vakhmistr")]), _vm._v(" (sergeants)."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent156",
      "id": "theft156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])])]), _vm._v(" Paul made efforts to curb the policy of enlisting noble infants in regiments. Under the new system, a nobleman could receive an officer’s rank after serving three years as a private and another three years as an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("estandart junker")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fanen junker")]), _vm._v(" in dragoons and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("portupey junker")]), _vm._v(" in light cavalry). On 12 November 1796, Paul abolished the rank of sub-lieutenant in the hussar regiments and ensigns were renamed to cornets. The following year, on 7 November 1797, he turned lieutenant captain into staff captain and the second "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rotmistr")]), _vm._v(" into staff "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rotmistr")]), _vm._v(". In the Cossack forces, the ranks were titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Polkovnik")]), _vm._v(" (colonel), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Voiskovoi")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("starshina")]), _vm._v(" (major), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esaul")]), _vm._v(" (captain), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sotnik")]), _vm._v(" (lieutenant), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Khorunzhii")]), _vm._v(" (cornet). In 1798, he introduced special ranks for non-commissioned officers: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("estandart-junker")]), _vm._v(" in heavy cavalry regiments, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fanen-junker")]), _vm._v(" in dragoon regiments, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("portupey-junker")]), _vm._v(" in light cavalry and artillery, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("portupey-praporshchik")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("portupey")]), _vm._v(" ensign) in the infantry."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent157",
      "id": "theft157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e90ce6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof40.vue
// module id = 213
// module chunks = 0